module.exports = __webpack_public_path__ + "img/program-icon-3.585befd6.png";